'use client';

import { useEffect, useState } from 'react';

import { useAppSelector } from '@/redux/hooks';
import { GmBarMobile } from './GmBarMobile';

export const GmBarMobileWrapper = () => {
  const userSession = useAppSelector(state => state.user.userSession);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted || !userSession) {
    return null;
  }

  return (
    <div>
      <GmBarMobile />
      <div className="h-18.25 lg:hidden" aria-hidden />
    </div>
  );
};
